import React from "react";
import _ from "lodash";

import {
  isSuccess,
  useLoadableSlice,
} from "../../store/shared/withLoadingState";
import { loadHelpContent } from "../../store/help/help.actions";
import { getHelp } from "../../store/help/help.reducer";

export const withHelpContent = (Component) => (props) => {
  const helpContent = useLoadableSlice(loadHelpContent(), getHelp);

  if (_.isNull(helpContent)) {
    return null;
  }

  if (!isSuccess(helpContent)) {
    throw Error("Help content loading failed");
  }

  return <Component {...props} />;
};
